import { extensibilityState } from 'owa-addins-store';

export default function isExtensibilityStateDirty(): boolean {
    return extensibilityState.ExtensibilityStateIsDirty;
}
